// extracted by mini-css-extract-plugin
export var externalLink = "_96-0";
export var internalLinkLabel = "_96-1";